import { cn } from "@/lib/utils/cn";
import type { HTMLAttributes, ReactNode } from "react";

interface SectionTitleProps extends HTMLAttributes<HTMLHeadingElement> {
  /** If provided, rendered inline with `text-gold` styling. */
  accent?: ReactNode;
  /** Tag override (defaults to h2; use h1 only for the page-level hero). */
  as?: "h2" | "h3";
  children: ReactNode;
}

export function SectionTitle({
  accent,
  as: Tag = "h2",
  className,
  children,
  ...rest
}: SectionTitleProps) {
  return (
    <Tag
      {...rest}
      className={cn(
        "font-display tracking-tight leading-[0.95] text-fg",
        "text-5xl sm:text-6xl lg:text-7xl",
        className
      )}
    >
      {children}
      {accent && <span className="text-gold"> {accent}</span>}
    </Tag>
  );
}
